import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import { SKIP_LOADER_HEADER } from '../services/utility.service';

@Injectable({
	providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {
	constructor(
		private loaderService: LoaderService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (request.headers.has(SKIP_LOADER_HEADER)) {
			const headers = request.headers.delete(SKIP_LOADER_HEADER);
			return next.handle(request.clone({ headers })).pipe(
				tap((/*event: HttpEvent<any>*/) => {
					// do nothing
				},
					(/*err: any*/) => {
						// do nothing
					}));
		}
		else {
			this.showLoader();
			return next.handle(request).pipe(
				tap((event: HttpEvent<any>) => {
					if (event instanceof HttpResponse) {
						this.onEnd();
					}
				},
					(/*err: any*/) => {
						this.onEnd();
					}));
		}
	}

	private onEnd(): void {
		this.hideLoader();
	}

	private showLoader(): void {
		this.loaderService.show();
	}

	private hideLoader(): void {
		this.loaderService.hide();
	}
}
